
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyA0mCzB_c899SCzDrz7ACql469SEMw5v4Y",
  authDomain: "internskool-d3e2f.firebaseapp.com",
  projectId: "internskool-d3e2f",
  storageBucket: "internskool-d3e2f.firebasestorage.app",
  messagingSenderId: "127523354054",
  appId: "1:127523354054:web:6dadd546e15c26da326ec7",
  measurementId: "G-SY66T56EXM"
};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { app, db, storage, analytics, auth };